import { useEffect, useState } from "react";

// How long typing has to pause before what is typed is asked for: the search of a list, of ⌘K, of a picker. One
// pause for all, so every keystroke is not a request.

const PAUSE_MS = 250;

/** The value once it has stopped changing for a pause; the first one at once. */
export function usePaused<T>(value: T): T {
  const [paused, setPaused] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setPaused(value), PAUSE_MS);
    return () => clearTimeout(timer);
  }, [value]);
  return paused;
}
